<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="secondary" light max-width="100%" width="400" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">Login</h1>
              <v-row>
                <v-col v-if="ssoGoogle">
                  <form id="google" name="google" action="/API/public/portal/login/google" method="GET">
                    <v-btn form="google" type="submit" class="ma-1" icon rel="noopener" target="_blank">
                      <v-icon v-text="'mdi-google'" />
                    </v-btn>
                  </form>
                </v-col>
                <v-col v-if="ssoFacebook">
                  <form id="facebook" name="facebook" action="/API/public/portal/login/facebook" method="GET">
                    <v-btn form="facebook" type="submit" class="ma-1" icon rel="noopener" target="_blank">
                      <v-icon v-text="'mdi-facebook'" />
                    </v-btn>
                  </form>
                </v-col><v-col v-if="ssoTwitter">
                  <form id="twitter" name="twitter" v-if="ssoTwitter" action="/API/public/portal/login/twitter"
                    method="GET">
                    <v-btn form="twitter" type="submit" class="ma-1" icon rel="noopener" target="_blank">
                      <v-icon v-text="'mdi-twitter'" />
                    </v-btn>
                  </form>
                </v-col>
              </v-row>


            </div>
          </template>

          <v-card-text class="text-center">
            <form id="basic" name="basic" method="post" action="javascript:void(0);" v-on:submit="doLogin('local')">
              <div v-if="ssoFacebook || ssoTwitter || ssoGoogle" class="text-center grey--text font-weight-light">
                {{ $t("or_classic_login") }}
              </div>

              <v-text-field color="secondary" v-model="email" :label="$t('email')" prepend-icon="mdi-email" />

              <v-text-field class="mb-8" color="secondary" :label="$t('password')" type="password" v-model="password"
                prepend-icon="mdi-lock-outline" />

              <v-btn color="success" depressed form="basic" type="submit" class="mx-2 v-btn--text">{{
                $t("login")
              }}
              </v-btn>

              <v-btn v-on:click="reqResetPassword" color="primary" depressed class="mx-2 v-btn--text">{{
                $t("password_lost")
              }}</v-btn>
            </form>
          </v-card-text>
          <p slot="error" class="text-danger">{{ message }}</p>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "PagesLogin",

  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  data: () => ({
    email: null,
    password: null,
    message: null,
    ssoGoogle: false,
    ssoFacebook: false,
    ssoTwitter: false,
  }),
  mounted() {
    let _ = this;
    localStorage.setItem("authToken", "");
    localStorage.setItem("rToken", "");
    this.ssoGoogle = window.systemData.SSO.google;
    this.ssoTwitter = window.systemData.SSO.twitter;
    this.ssoFacebook = window.systemData.SSO.facebook;
    // Controlla SSO Response
    const ssoResponse = this.getQueryParameterByName('ssoResponse');
    if (ssoResponse) {
      try {
        let decoded = decodeURIComponent(atob(ssoResponse).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        let json = JSON.parse(decoded)
        if (json.msg.severity > 0) {
          window.location = "/#/auth/login/"
          Swal.fire({
            title: _.$t("there_was_an_error"),
            type: "error",
            text: json.msg.msgTxt,
          })
        } else {
          _.setAuthToken(json.data.token, window.location.href);
        }
      } catch (e) {
        console.dir(e)
        window.location = "/#/auth/login/"
        Swal.fire({
          title: _.$t("there_was_an_error"),
          type: "error",
          html: _.$t("sso_response_invalid")
        })
      }
    }
  },
  methods: {
    doLogin: function (type, event) {
      let _ = this;

      _.axios({
        method: "POST",
        url: "/public/portal/login",
        timeout: 5000,
        headers: {
          local: window.selectedLanguage,
        },
        data: {
          type: type,
          username: _.email,
          password: _.password,
        },
      })
        .then(function (json) {
          if (json.data.msg.severity > 0) {
            _.message = json.data.msg.msgTxt;
            Swal.fire({
              title: _.$t("there_was_an_error"),
              type: "error",
              html: json.data.msg.msgTxt,
            })
          } else {
            _.setAuthToken(json.data.data.token, window.location.href);
          }
        })
        .catch((error) => {
          console.dir(error);
        });
    },
    reqResetPassword: function (event) {
      let _ = this;

      Swal.fire({
        title: _.$t("request_reset_password"),
        html: _.$t("reset_password_will_be_send"),
        showCancelButton: true,
        confirmButtonText: "Send email",
      }).then((result) => {
        if (result.value) {
          this.axios({
            method: "POST",
            url: "/public/portal/requestResetPassword",
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              local: window.selectedLanguage,
            },
            data: {
              email: _.email,
            },
          }).then(function (json) {
            if (json.data.msg.severity > 0) {
              _.message = json.data.msg.msgTxt;
              Swal.fire({
                title: _.$t("there_was_an_error"),
                html: json.data.msg.msgTxt,
              });
            } else {
              _.message = json.data.msg.msgTxt;
              Swal.fire({
                title: _.$t("operation_successfully_completed"),
                html: _.$t("reset_password_sent"),
              });
            }
          });
        }
      });
    },
  },
};
</script>
